module.exports = __webpack_public_path__ + "static/img/banner01.b53fb4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/banner01.png
// module id = FVos
// module chunks = 1